import { render, staticRenderFns } from "./OrderDetailsHeader.vue?vue&type=template&id=50d454a0&scoped=true"
import script from "./OrderDetailsHeader.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d454a0",
  null
  
)

export default component.exports